import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  SALES_PRODUCT_TAB_ITEMS,
  type SalesProductTabId,
} from "./SalesProductAnalyticsTabsDashboard.data";
import { OverviewSection } from "./SalesProductOverviewSection";
import { SalesSection } from "./SalesProductSalesSection";
import { InventorySection } from "./SalesProductInventorySection";
import { CustomersSection } from "./SalesProductCustomersSection";
import { AttributionSection } from "./SalesProductAttributionSection";
import "./SalesProductAnalyticsTabsDashboard.scss";

const SalesProductAnalyticsTabsDashboard: FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<SalesProductTabId>("overview");
  const [dateRange, setDateRange] = useState(() => {
    const end = dayjs();
    const start = end.subtract(30, "day");
    return {
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    };
  });
  return (
    <div className="sales-product-analytics-dashboard">
      <div className="sales-product-analytics-dashboard__tabs">
        {SALES_PRODUCT_TAB_ITEMS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`sales-product-analytics-dashboard__tab ${activeTab === tab.id ? "sales-product-analytics-dashboard__tab--active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {t(`salesProduct.tabs.${tab.id}`, { defaultValue: tab.label })}
          </button>
        ))}
      </div>

      {activeTab === "overview" ? (
        <OverviewSection
          dateRange={dateRange}
          setDateRange={setDateRange}
        />
      ) : null}
      {activeTab === "sales" ? (
        <SalesSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
      {activeTab === "inventory" ? (
        <InventorySection dateRange={dateRange} />
      ) : null}
      {activeTab === "customers" ? (
        <CustomersSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
      {activeTab === "attribution" ? (
        <AttributionSection
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      ) : null}
    </div>
  );
};

export default SalesProductAnalyticsTabsDashboard;
